import { useTranslation } from 'react-i18next';

import { Badge } from '@nucleus-commerce/ui/components/badge';
import { cn } from '@nucleus-commerce/ui/lib/utils';

/** "manual" is the only source today; a provider name is shown as-is until it gets its own key. */
export function RateSourceBadge({ source, className }: { source: string; className?: string }) {
  const { t } = useTranslation('exchangeRates');
  const manual = source === 'manual';
  return (
    <Badge
      variant="outline"
      data-source={source}
      className={cn(manual ? 'text-muted-foreground' : 'border-info/40 text-info', className)}
    >
      {manual ? t('source.manual') : t('source.other', { source })}
    </Badge>
  );
}
